// extracted by mini-css-extract-plugin
export default {"formControlLabel":"styles_formControlLabel__5ZmR3"};